import * as React from "react";
import { Link, PrimaryButton, IButtonProps } from "office-ui-fabric-react";
import Header from "./Header";
import Footer from "./Footer";
import ReactDOM = require("react-dom");
import App from "./App";
import { ImageUrls, getDomain } from "../environments/ConfigDetails";

export interface SuccessMessageProps {
  selectedMatter;
  isLoggedIn: boolean;
  workspaceUrlPrefix: string;
  workspaceUrltld: string;
}

export interface SuccessMessageState {}

class SuccessMessage extends React.Component<
  SuccessMessageProps,
  SuccessMessageState
> {
  constructor(props, {}) {
    super(props, {});
  }
  render() {
    const matterUrl = getDomain({ workspace: this.props.workspaceUrlPrefix, tld: this.props.workspaceUrltld, path: this.props.selectedMatter.url || '' })

    return (
      <div>
        <Header
          title={`Matter Management`}
          isLoggedIn={this.props.isLoggedIn}
        />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
              style={{
                position: "absolute",
                margin: "auto",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                height: "180px",
                textAlign: "center"
              }}
            >
              <img
                src={ImageUrls.tickImage}
                style={{
                  width: "20%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block"
                }}
              />
              <br />
              <span
                style={{
                  fontFamily: "Lato",
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#0E3A6E",
                  paddingLeft: "10px"
                }}
              >
                You've successfully saved!
              </span>
              <br />
              <br />
              <span
                style={{
                  fontFamily: "Lato",
                  fontSize: 14,
                  fontWeight: "normal",
                  color: "#0E3A6E",
                  paddingLeft: "10px"
                }}
              >
                To see your matter in SimpleLegal
              </span>{" "}
              <Link
                style={{
                  fontFamily: "Lato",
                  fontSize: 14,
                  fontWeight: "normal"
                }}
                href={matterUrl}
                target={"blank"}
              >
                click here.
              </Link>
              <br />
              <br />
              <PrimaryButton
                className="saveBtn"
                primary={true}
                data-automation-id="test"
                disabled={false}
                text="OK"
                onClick={this.backToHome}
                style={{
                  backgroundColor: "#0E3A6E",
                  fontFamily: "Lato",
                  fontWeight: "normal",
                  fontSize: 16,
                  height: 35,
                  width: "100%"
                }}
                onRenderText={this.onRenderBtnText}
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  backToHome = () => {
    //get saved matters
    let savedMatters = [];
    let item = Office.context.mailbox.item;
    item.loadCustomPropertiesAsync(asyncResult => {
      let customProps = asyncResult.value;

      let matters = customProps.get("SavedMatters");
      if (typeof matters !== "undefined") {
        savedMatters = matters;
      }
    });
    ReactDOM.render(
      <App
        title={"SimpleLegal"}
        isOfficeInitialized={true}
        savedMatters={savedMatters}
        isItemChanged={false}
        isLoggedIn={true}
      />,
      document.getElementById("container")
    );
  };
  onRenderBtnText = (_props: IButtonProps): JSX.Element => {
    return (
      <div
        style={{
          textAlign: "center",
          fontFamily: "Lato",
          fontSize: 16,
          fontWeight: "normal",
          paddingBottom: 2
        }}
      >
        OK
      </div>
    );
  };
}

export default SuccessMessage;
